import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';

export const FormArrayError = ({ name }) => (
  <Field
    name={name}
    subscribe={{ touched: true, error: true }}
    render={({ meta: { dirty, error } }) =>
      dirty && error && typeof error === 'string' ? (
        <div className="row error">{error}</div>
      ) : null
    }
  />
);

FormArrayError.propTypes = {
  name: PropTypes.string.isRequired,
};

export const FormError = ({ name }) => (
  <Field
    name={name}
    subscribe={{ touched: true, error: true }}
    render={({ meta: { touched, error } }) =>
      touched && error && typeof error === 'string' ? (
        <div className="row error">{error}</div>
      ) : null
    }
  />
);

FormError.propTypes = {
  name: PropTypes.string.isRequired,
};

const FormField = ({
  name,
  containerClassName,
  inputClassName,
  labelClassName,
  placeholder,
  validate,
  label,
  textArea,
  rows,
  cols,
  disabled,
  onKeyPress,
  onChangeCallback,
}) => {
  return (
    <Field
      name={name}
      containerClassName={containerClassName}
      inputClassName={inputClassName}
      labelClassName={labelClassName}
      placeholderText={placeholder}
      validate={validate}
      fieldLabel={label}
      fieldDisabled={disabled}
      format={(value = '') => {
        if (typeof value !== 'string') return value;
        return value.trim();
      }}
      formatOnBlur
      render={({
        input,
        inputClassName,
        labelClassName,
        containerClassName,
        placeholderText,
        meta,
        fieldLabel,
        fieldDisabled,
      }) => {
        const inputClassNames = [];
        const error = meta.touched && meta.error ? 'border-danger' : null;
        if (inputClassName) inputClassNames.push(inputClassName);
        if (error) inputClassNames.push(error);

        return (
          <div className={containerClassName}>
            {label && (
              <label htmlFor={input.name} className={labelClassName}>
                {fieldLabel}
              </label>
            )}
            {textArea ? (
              <textarea
                className={inputClassNames.join(' ')}
                id={input.name}
                placeholder={placeholderText}
                disabled={fieldDisabled}
                rows={rows}
                cols={cols}
                {...input}
              />
            ) : (
              <input
                {...input}
                className={inputClassNames.join(' ')}
                id={input.name}
                placeholder={placeholderText}
                disabled={fieldDisabled}
                onKeyPress={onKeyPress}
                onChange={e => {
                  const { value } = e.target;
                  if (onChangeCallback) onChangeCallback(value);
                  input.onChange(value);
                }}
              />
            )}
            <FormError name={input.name} />
          </div>
        );
      }}
    />
  );
};

FormField.defaultProps = {
  containerClassName: '',
  inputClassName: '',
  labelClassName: '',
  placeholder: '',
  disabled: false,
  textArea: false,
};

FormField.propTypes = {
  name: PropTypes.string.isRequired,
  containerClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  placeholder: PropTypes.string,
  validate: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  textArea: PropTypes.bool,
};

export default FormField;



// WEBPACK FOOTER //
// ./src/components/Form/FormField.js